import { DateTime } from "luxon"
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon"
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { Alert, Button, Grid, IconButton, Typography } from "@mui/material"
import TableMaker, { TableMakerType } from "../../assets/TableMaker"
import PreLoader from "../../PreLoader"
import { useAxios } from "../../../hooks/useAxios"
import { useServiceSchedule } from "./useServiceSchedule"
import { ViewScheduleService } from "../types"
import { Add, DeleteForever } from "@mui/icons-material"

const API_URL = process.env.REACT_APP_NOTIFIER

export default function ServiceSchedules({ id }: { id: number }) {

    const {
        data,
        error,
        isLoading,
        fetchData: refetchSschedules
    } = useAxios<ViewScheduleService[]>(`${process.env.REACT_APP_NOTIFIER_URL}/automated_service_schedule/${id}`)

    const {
        date,
        setDate,
        isHandlingUpdateOrCreate,
        handleUpdateOrCreate,
        handleDelete
    } = useServiceSchedule(refetchSschedules)

    const format: TableMakerType<ViewScheduleService>[] = [
        { field: 'id', header: 'ID', width: .5 },
        { field: 'send_date', header: 'Send Date', width: 1, flexGrow: true, renderComponent: (value) => <Typography>{DateTime.fromISO(String(value)).toFormat('dd-LLL-yy HH:mm')}</Typography> },
        { field: 'id', header: '', width: .5, renderComponent: (value) => <IconButton onClick={() => handleDelete(`${API_URL}/automated_service_schedule/${value}`)}><DeleteForever /></IconButton> },
    ]

    if (isLoading) return <PreLoader />

    if (error) return <Alert severity="error">Error while loading schedules.</Alert>

    return (
        <Grid container spacing={1}>
            <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <DateTimePicker
                        slotProps={{ textField: { id: 'service-schedule-date' } }}
                        label='Date & Time'
                        format="dd-LLL-yy HH:mm"
                        value={date ? DateTime.fromISO(date) : null}
                        onChange={(newValue) => setDate(newValue!.toISO({ includeOffset: false }) ?? '')}
                    />
                </LocalizationProvider>
            </Grid>

            <Grid item xs={5}></Grid>

            <Grid item xs={3}>
                <Button
                    startIcon={<Add />}
                    disabled={isHandlingUpdateOrCreate}
                    onClick={() => handleUpdateOrCreate('POST', `${API_URL}/automated_service_schedule`, { fk_id_automated_service: id, send_date: date }
                    )}>Add</Button>
            </Grid>

            <Grid item xs={12}>
                <TableMaker
                    format={format}
                    data={data || []}
                />
            </Grid>
        </Grid>

    )
}
